import Endpoint from "../../services/api/endpoint";
import { IProductType } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<IProductType>(Endpoint.ProductTypes, Endpoint.ProductTypesList);